// Fragment "catalog and HQ social labels" — the closed vocabularies the Product Catalog
// (super_admin/CatalogManager.jsx) and HQ Social (super_admin/HqSocial.jsx) used to print raw:
// a SKU's category (backend SkuCreate.category), the featured flag, a booster's price suffix and
// on-sale state, and a social post's status (super_admin_hq_routes.create_post). Merged by ./index.js.
export default {
  fr: {
    "cat.category.install": "Installation",
    "cat.category.data_porting": "Reprise de données",
    "cat.featured": "En vedette",
    "cat.perMonth": "/mois",
    "cat.onSale": "En vente",
    "cat.notForSale": "Retiré de la vente",
    "hsoc.status.scheduled": "Programmée",
    "hsoc.status.published": "Publiée",
  },
  en: {
    "cat.category.install": "Install",
    "cat.category.data_porting": "Data porting",
    "cat.featured": "Featured",
    "cat.perMonth": "/mo",
    "cat.onSale": "On sale",
    "cat.notForSale": "Not for sale",
    "hsoc.status.scheduled": "Scheduled",
    "hsoc.status.published": "Published",
  },
  es: {
    "cat.category.install": "Instalación",
    "cat.category.data_porting": "Migración de datos",
    "cat.featured": "Destacado",
    "cat.perMonth": "/mes",
    "cat.onSale": "En venta",
    "cat.notForSale": "Retirado de la venta",
    "hsoc.status.scheduled": "Programada",
    "hsoc.status.published": "Publicada",
  },
};
